export const RECEIVE_LOADING = "RECEIVE_LOADING";

export const receiveLoading = loading => ({
  type: RECEIVE_LOADING,
  loading
});

export const changeLoading = loadingState => dispatch =>
  dispatch(receiveLoading(loadingState));
